<template>
    <div class="max-w-screen-xl mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-18 mb-12 lg:px-0 px-4">
        <h2 class="text-center mx-auto max-w-6xl text-2xl sm:text-3xl lg:text-4xl font-medium mb-10" v-html="example.title"></h2>
        <div class="text-lg md:text-xl" v-html="example.description"></div>
    </div>
</template>
<script lang="ts">
export default defineComponent({
    props: {
        example: {
            type: Object,
            default: {}
        }
    }
})
</script>